export default {
      id: "email-usage",
      viewBox: "0 0 20 14",
      url: "/" + "sprite.svg#email",
      toString: function () {
        return this.url;
      }
    }